// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const centiskorch_gmax: PokeData = {
  "id": 10220,
  "name": "centiskorch-gmax",
  "height": 750,
  "weight": 10000,
  "base_experience": 184,
  "types": [
    PokeType.FIRE,
    PokeType.BUG
  ],
  "api_moves": [],
  "moves": [
    "fire-fang",
    "infest",
    "bug-bite",
    "pin-rush",
    "pounce",
    "fire-punch",
    "fire-ball",
    "sunny-day",
    "morning-sun",
    "flamethrower",
    "blaze-kick",
    "lunge",
    "string-shot"
  ],
  "evolution_chain": {
    "id": 447,
    "item": null,
    "species": [
      {
        "name": "sizzlipede",
        "order": 850,
        "types": [
          PokeType.FIRE,
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "centiskorch",
        "order": 851,
        "types": [
          PokeType.FIRE,
          PokeType.BUG
        ],
        "evolves_from_species_id": 850,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 132,
    "speed": 97,
    "ability_power": 171
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
